export default class NavTrigger {
  constructor() {
    this.trigger = document.querySelectorAll(".js-nav-trigger");
  }

  init() {
    this.events();
  }

  //TODO: refactor to vanilla JS
  events() {
    $(".js-nav-trigger, .js-nav-sub-bg, .js-nav-sub-item")
      .off()
      .on("click", () => {
        this.openAndCloseMenu();
      });
  }

  openAndCloseMenu() {
    if ($("body").hasClass("-nav-open")) {
      // commonObject.scroll.start();
      $("body").addClass("-nav-closing");
      setTimeout(() => {
        $("body").removeClass("-nav-open -popup-open -nav-closing");
      }, 1000);
      $(".js-nav-trigger").removeClass("-is-open");
      $(".js-menu").removeClass("-is-open");
    } else {
      // commonObject.scroll.stop();
      $("body").addClass("-nav-open");
      $(".js-nav-trigger").addClass("-is-open");
      $(".js-menu").addClass("-is-open");
    }
  }

  render() {
    //
  }
}



// WEBPACK FOOTER //
// ./scripts/components/navTrigger.js